import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { spaceGroupsKeys } from 'src/features/space-groups/api/query-keys/space-groups';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';
import { assignSpaceGroupsToEmployeeGroup } from '../../lib/employees-group-space-groups';
import { employeesGroupsKeys } from '../../query-keys/employees-groups';

export const useAssignSpaceGroupsToEmployeeGroup = (onSuccess?: () => void) => {
  const { t } = useTranslation(['employeesGroups', 'common']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      token,
      spaceGroupTokens,
    }: {
      token: string;
      spaceGroupTokens: string[];
    }) => assignSpaceGroupsToEmployeeGroup(token, spaceGroupTokens),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: employeesGroupsKeys.lists(),
        });

        queryClient.invalidateQueries({
          queryKey: spaceGroupsKeys.lists(),
        });
      });

      toast.success(
        t(
          'employeesGroups:spaceGroups.assignSpaceGroupToEmployeeGroupDialog.successMessage',
        ),
      );

      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(
        error?.response?.data?.message ||
          t('common:errorMessages.somethingWentWrong'),
      );
    },
  });
};
